module.exports = __webpack_public_path__ + "static/media/designspecs-2.94c15ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/how-can-be-used/assets/designspecs-2.png
// module id = 89
// module chunks = 0